import { useState } from "react";
import CWBrowserLogo from "../../../CWBrowserLogo";
import LockScreenImg from "../../../../assets/images/lockScreen.svg";
import Online from "../../../../assets/images/green.svg";
import Offline from "../../../../assets/images/red.svg";
import useAuthStore from "../../../../stores/useAuthStore";
import "../modals/v4Modals.css";

const SMLockScreen = ({
  isLocked,
  isOnline,
  userData,
  username,
  handleLogin,
}) => {
  // BUG-2066: mirrors the re-entrancy guard in useSuperMarketActions'
  // handleLogin — disabling the button on the first click, in addition to
  // that guard, stops a mashed Sign In from even attempting extra clicks.
  const [signingIn, setSigningIn] = useState(false);

  if (!userData) return null;

  const tillName = useAuthStore.getState().tillValue?.name;

  const onSignInClick = () => {
    // Only disable when this click will actually navigate away — handleLogin's
    // offline branch just shows an error and stays on this screen, so it must
    // stay clickable for a retry once the network is back.
    if (isOnline) setSigningIn(true);
    handleLogin();
  };

  return (
    <div className="v4m v4m-lock" style={{ display: isLocked ? "flex" : "none" }}>
      {/* Top-right status bar */}
      <div className="v4m-lock-status">
        {tillName && (
          <span>
            Till: <strong>{tillName}</strong>
          </span>
        )}
        <img src={isOnline ? Online : Offline} style={{ height: "16px" }} alt={isOnline ? "Online" : "Offline"} />
      </div>

      <div className="v4m-lock-wrap">
        <div className="v4m-lock-logo">
          <CWBrowserLogo size={28} variant="light" />
        </div>

        <div className="v4m-lock-card" role="dialog" aria-modal="true" aria-labelledby="v4m-lock-title">
          <div className="v4m-lock-icon">
            <img src={LockScreenImg} alt="" />
          </div>

          <h2 id="v4m-lock-title" className="v4m-title">
            Screen Locked
          </h2>
          <p className="v4m-sub">Sign in to unlock your session</p>

          <label className="v4m-label" htmlFor="v4m-lock-user">
            Username
          </label>
          <input id="v4m-lock-user" readOnly type="text" value={username} className="v4m-lock-user" />

          <button type="button" className="v4m-bp v4m-block" onClick={onSignInClick} disabled={signingIn}>
            {signingIn ? "Signing in..." : "Sign In"}
          </button>
        </div>

        <p className="v4m-lock-foot">CW Browser — Secure Business Workspace</p>
      </div>
    </div>
  );
};

export default SMLockScreen;
